import { Grid, Paper, Typography, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useState } from "react";
import { useAddLoadPricingConfigMutation, useGetAllLoadPricingConfigByClientIdQuery } from '../../../../pricingRubricSlice';
import { vehicle_detail_extended_type, vehicleDetailExtendedValues } from 'features/vehicles/VehicleDetailExtended/VehicleDetailExtendedTypes';
import configStyles from "../../../configStyles";
import LoadPricingConfigEditor from "./LoadPricingConfigEditor";
import NotificationProvider from "components/NotificationProvider";

const useStyles = configStyles;

const TransportSlaLoadsPricingConfig = ({ clientId }) => {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(null);

  const assetClasses = vehicleDetailExtendedValues[vehicle_detail_extended_type.VehicleWeightClass] || [];

  const [addLoadPricingConfigEditor] = useAddLoadPricingConfigMutation();
  const { data: rubricData, isLoading } = useGetAllLoadPricingConfigByClientIdQuery(clientId, { skip: !clientId });

  const rubricList = isLoading ? {} : rubricData || {};

  const getRanges = (assetClass) => {
    return Array.isArray(rubricList[assetClass.id]) ? rubricList[assetClass.id] : [];
  };

  const handleAddRange = async (assetClass, ranges) => {
    const payload = {
      ranges: ranges,
      assetClass: assetClass.id,
      clientId
    };

    let result = await addLoadPricingConfigEditor(payload);

    if (result && !result.error) {
        NotificationProvider.success("Weight class pricing saved successfully");
    } else {
        NotificationProvider.error("Failed to save the weight class pricing");
    }
  };

  return (
    <Paper className={classes.card}>
      <Grid container>
        <Grid item xs={12} className={classes.titleWrapper}>
          <div className={classes.title}>Pricing Rubric</div>
        </Grid>
      </Grid>
      <Grid container spacing={2} direction="column">
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {assetClasses.map((assetClass, i) => (
              <Grid item xs={12} key={assetClass.id}>
                <Accordion
                  expanded={expanded === assetClass}
                  onChange={() => setExpanded(expanded === assetClass ? null : assetClass)}
                >
                  <AccordionSummary className={classes.listItem} expandIcon={<ExpandMoreIcon />}>
                    <Typography>{assetClass.name}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <LoadPricingConfigEditor
                      assetClass={assetClass}
                      ranges={getRanges(assetClass)}
                      onSaveAssetClass={handleAddRange}
                      clientId={clientId}
                    />
                  </AccordionDetails>
                </Accordion>
              </Grid>
            ))}

          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default TransportSlaLoadsPricingConfig;
